import { NavLink } from 'react-router-dom';
import { useIsMobile } from 'src/helpers/useIsMobile';
import { Flex } from '../UI/Flex';

interface SidebarButtonProps {
  children: React.ReactNode[];
  pathTo: string;
  onClick?: () => void;
}

export const SidebarButton = (props: SidebarButtonProps) => {
  const isMobile = useIsMobile();

  const baseStyle = {
    width: '100%',
    height: isMobile ? '137px' : '62px',
    borderRadius: '20px',
    padding: '20px',
    boxShadow: isMobile ? '3px 3px 10px rgba(61, 14, 107, 0.1)' : 'none',
    backgroundColor: '#fff',
    borderWidth: isMobile ? '0px' : '2px',
    borderColor: '#FFE4EB',
    transition: 'all 0.3s',
  };

  const activeStyle = {
    ...baseStyle,
    backgroundColor: '#FFE4EB',
  };

  return (
    <NavLink to={props.pathTo} style={({ isActive }) => (isActive ? activeStyle : baseStyle)} onClick={props.onClick}>
      <Flex alignItems={'center'} justifyContent={'flex-start'} h={'100%'} w={'100%'} flexDirection={'row'}>
        {props.children}
      </Flex>
    </NavLink>
  );
};
